<template>
    <div class="box">
        <div class="contaner-title"><span>个人中心</span> <span>/ 用户管理</span></div>
        <div class="hr"></div>
       
        <div class="contaner">
           <div><img src="../../assets/user_icon.png" alt=""> <span>用户资料</span><Button type="primary" @click="modal2=true">修改密码</Button></div>
             <div>
                 <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="200">
                      <!-- <FormItem label="用户ID" prop="userName">
                         <span style="line-height:34px;">{{formValidate.ID}}</span>
                      </FormItem> -->
                    <FormItem label="联系人" prop="Realname">
                        <Input style="width:156px;" v-model="formValidate.Realname" placeholder="请输入联系人姓名"></Input>
                    </FormItem>
                    <FormItem label="手机号" prop="Tel" style="position:relative;">
                        
                           <span class="country-title" @click="isCountry=!isCountry">{{countries}}<Icon type="ios-arrow-down" /></span>
                        <ul class="country" v-if="isCountry">
                                <li v-for="(item,index) in allCountries" @click="chooseCountry(item[2])" :key="index">{{item[0] + item[2] }}</li>
                            </ul>
                        <Input style="width:156px;" :readonly="!isMobile" v-model="formValidate.Tel" placeholder="请输入手机号码"></Input>
                        <Button type="primary" @click="isMobile=true">修改手机号</Button>
                    </FormItem>
                    <FormItem label=" " prop="mobileCode" v-show="isMobile">
                        <Input style="width:156px;" v-model="formValidate.mobileCode" placeholder=""></Input>
                        <Button type="primary" :disabled="isdisabled" @click="sendTel">获取手机验证码 <span v-if="isdisabled">{{Time}}s</span></Button>
                    </FormItem>
                    <FormItem label="绑定邮箱" prop="Email">
                        <!--  -->
                        <Input :readonly="!isEmail"  style="width:156px;" v-model="formValidate.Email" placeholder=""></Input>
                        <Button type="primary" @click="isEmail=true" >绑 定 邮 箱</Button>
                    </FormItem>
                        <FormItem label=" " prop="mailCode" v-show="isEmail">
                      
                        <Input style="width:156px;" v-model="formValidate.mailCode" placeholder=""></Input>
                        <Button type="primary" :disabled="ismailDisabled" @click="sendEmail">获取邮箱验证码 <span v-if="ismailDisabled">{{emailTime}}s</span></Button>
                    </FormItem>
                    <FormItem label="联系QQ" prop="QQ">
                        <Input style="width:156px;" v-model="formValidate.QQ" placeholder="请输入QQ"></Input>
                    </FormItem>
                    <FormItem label="联系微信" prop="WX">
                        <Input style="width:156px;" v-model="formValidate.WX" placeholder="请输入微信"></Input>
                    </FormItem>
                    <FormItem label="擅长项目" prop="Fields">
                         <div>
                             <Tree :data="data2" show-checkbox @on-check-change="checkChange"></Tree>
                         </div>
                    </FormItem>
                    <FormItem label="技术标签" prop="Skill" class="tab-form">
                    <div class="tab-btn">
                        <Input style="width:474px;" v-model="tagName" placeholder="输入标签后按回车添加" @on-enter="enterTag"></Input>
                            <!-- <span ><Icon type="md-add" /></span><span>点击添加标签</span> -->
                    </div>
                        <div class="tab-list">
                            <span  :class="{'active':formValidate.Skill.indexOf(item)>-1}" v-for="(item,index) in TabList" :key="index" @click="chooseSkill(item)">+ {{item}}</span>
                        </div>
                    </FormItem>
                    <FormItem label="工作地" prop="Address">
                        <area-select v-if="showArea" v-model="formValidate.Address" :data="$pcaa" :level="2"></area-select>  
                    </FormItem>
                    <FormItem label="支付宝账号" prop="Alipay">
                        <Input style="width:474px;"  v-model="formValidate.Alipay"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="支付宝实名" prop="AlipayRealname">
                        <Input style="width:474px;"  v-model="formValidate.AlipayRealname"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="银行卡号" prop="BankNo">
                        <Input style="width:474px;"  v-model="formValidate.Bank.Account"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="户名" prop="AccountName">
                        <Input style="width:474px;"  v-model="formValidate.Bank.Name"  placeholder=""></Input>
                    </FormItem>
                    <FormItem label="开户行" prop="OpenBank">
                        <Input style="width:474px;"  v-model="formValidate.Bank.Username"  placeholder=""></Input>
                    </FormItem>
                       <Form-item>
                    <div class="btn-sub">
                        <Button type="success" size="large" @click="handleSubmit('formValidate')"> 保 存 </Button>
                        <!-- <Button @click="handleReset('formValidate')" size="large"  style="margin-left: 8px"> 取 消 </Button> -->
                    </div>
                       </Form-item>
                </Form>
             </div>
        </div>
         <changePws :modal2="modal2" @clickLogin="sureChange"></changePws>
</div>
</template>
<script>
import changePws from "../../components/changePws.vue"
export default {
    components:{
       changePws
    },
    data(){
        return{
            allCountries:this.$allCountries,
            countries:'',
            Time:60,
            isCountry:false,
            isdisabled:false,
            ismailDisabled:false,
            emailTime:60,
            modal2:false,
            listFiel:[],
            tagName:'',
            formValidate: {
                    ID:0,
                    Realname: '',//联系人
                    Tel:'',//手机号
                    mobileCode:'',//手机验证码
                    Email: '',//邮箱
                    mailCode:'',//验证码
                    QQ:'',
                    WX:'',
                    Fields:[],//项目
                    Skill:[],//标签
                    Address: [],
                    Alipay:'',//支付宝
                    AlipayRealname:'',//支付宝实名
                    Bank:{
                        Username:'',
                        Account:'',
                        Name:''
                    }
                },
                isMobile:false,//修改手机号
                isEmail:false,
                ruleValidate: {
                   Realname: [
                        { required: true,message: '联系人不能为空', trigger: 'blur' }
                    ],
                    // mobileCode
                    Tel: [
                        { required: true, message: '手机号码不能为空', trigger: 'blur' },
                        { type: 'string',pattern:/^1[3456789]\d{9}$/, message:'请输入正确的手机格式', trigger:'blur'}
                    ],
                    Email: [
                        { required: true, message: '邮箱不能为空',trigger: 'blur'},
                        { type: 'email', message: '邮箱格式不正确',trigger: 'blur'}
                    ],
                    Fields: [
                        { required: true,type: 'array', message: '请选择你擅长的项目', trigger: 'change' }
                    ],
                    Address: [
                        { required: true,type: 'array', message: '请选择工作地', trigger: 'change' }
                    ]
                },
                TabList:[],
                showArea:false,
                FieldList:[],
                FileType:[],
                data2: [
                            {
                            title: "2D",//设计稿','一原','二原','动上','摄影','背景
                            expand: false,
                            children: [{
                                title: "设计稿",
                                expand: false,
                                checked:false
                            },{
                                title: "一原",
                               expand: false,
                                 checked:false
                            },{
                                title: "二原",
                               expand: false,
                                 checked:false
                            },{
                                title: "动上",
                                expand: false,
                                  checked:false
                            },{
                                title: "摄影",
                               expand: false,
                                 checked:false
                            },{
                                title: "背景",
                                 expand: false,
                                   checked:false
                            }]
                            },{
                                title: "3D",//设计稿','一原','二原','动上','摄影','背景
                            children: [{
                                title: "人物模型",
                                 expand: false,
                                   checked:false
                            },{
                                title: "人物材质",
                                 expand: false,
                                   checked:false
                            },{
                                title: "场景模型",
                                 expand: false,
                                   checked:false
                            },{
                                title: "场景材质",
                                 expand: false,
                                   checked:false
                            },{
                                title: "绑定",
                                 expand: false,
                                   checked:false
                            },{
                                title: "动画",
                                 expand: false,
                                   checked:false
                            },{
                                title: "特效",
                                 expand: false,
                                   checked:false
                            },{
                                title: "灯光",
                                 expand: false,
                                   checked:false
                            },{
                                title: "渲染",
                                 expand: false,
                                   checked:false
                            }]
                            },{
                                title: "平面",//设计稿','一原','二原','动上','摄影','背景
                                 expand: false,
                                   checked:false,
                            children: [{
                                title: "海报",
                                 expand: false,
                                   checked:false
                            },{
                                title: "插画",
                                 expand: false,
                                   checked:false
                            },{
                                title: "立绘",
                                 expand: false,
                                   checked:false
                            }]
                            },{
                                title: "大后期",//设计稿','一原','二原','动上','摄影','背景
                                 expand: false,
                                   checked:false,
                            children: [{
                                title: "配音",
                                 expand: false,
                                   checked:false
                            },{
                                title: "音乐",
                                 expand: false,
                                   checked:false
                            },{
                                title: "音效/混音",
                                 expand: false,
                                   checked:false
                            }]
                            },{
                                title: "前期",//设计稿','一原','二原','动上','摄影','背景
                                 expand: false,
                                   checked:false,
                            children: [{
                                title: "分镜",
                                 expand: false,
                                   checked:false
                            },{
                                title: "剧本",
                                 expand: false,
                                   checked:false
                            },{
                                title: "人设",
                                 expand: false,
                                   checked:false
                            },{
                                title: "场设",
                                 expand: false,
                                   checked:false
                            },{
                                title: "道具",
                                 expand: false,
                                   checked:false
                            }]
                            },{
                                title:'3渲2',
                                 expand: false,
                                   checked:false,
                               children:[]
                            },{
                                title:'其他',
                                 expand: false,
                               checked:false,
                               children:[]
                            }
                                
                            ]

        }
    },
    mounted(){
        this.formValidate=JSON.parse(this.$getLS('AdminInfo'));
        this.countries=this.formValidate.TelCode;
        if(!this.formValidate.Skill){
            this.formValidate.Skill=[];
        }else{
            this.TabList=this.formValidate.Skill.split(',');
            this.formValidate.Skill=this.formValidate.Skill.split(',');
        }
         if(!this.formValidate.Address){
            this.showArea = false;
            this.formValidate.Address=[];
            this.$nextTick(() => {
                 this.showArea = true;
               })
        }else{
            this.formValidate.Address=[this.formValidate.Address.Province,this.formValidate.Address.City,this.formValidate.Address.Area]
            this.$nextTick(() => {
                  this.showArea = true;
              })
        }
        if(!this.formValidate.Bank){
            this.formValidate.Bank={Username:'', Account:'',Name:''}
        }
         if(!this.formValidate.Fields){
            this.formValidate.Fields=[];
        }else{
            var arr=[];
            this.formValidate.Fields.forEach(item=>{
                if(item.split('-')[1]){
                    arr.push(item.split('-')[1])
                }else{
                    arr.push(item)
                }
            })
            this.data2.forEach(item=>{
                item.children.forEach(it=>{
                      if(arr.indexOf(it.title)>-1){
                            it.checked=true;
                        }
                })
                if(arr.indexOf(item.title)>-1){
                    item.checked=true;
                }
            })
        }
    },
    methods:{
          chooseCountry(code){
            this.countries=code;
            this.isCountry=false;
        },
        checkChange(arr,it){
            this.formValidate.Fields=[];
            arr.forEach(item=>{
                if(item.title=='设计稿'||item.title=='一原'||item.title=='二原'||item.title=='动上'||item.title=='摄影'||item.title=='背景'){
                    this.formValidate.Fields.push('2D-'+item.title)
                }else if(item.title=='海报'||item.title=='插画'||item.title=='立绘'){
                    this.formValidate.Fields.push('平面-'+item.title)
                }else if(item.title=='人物模型'||item.title=='人物材质'||item.title=='场景模型'||item.title=='场景材质'||item.title=='绑定'||item.title=='动画'||item.title=='特效'||item.title=='灯光'||item.title=='渲染'||item.title=='后期'){
                    this.formValidate.Fields.push('3D-'+item.title)
                }else if(item.title=='配音'||item.title=='音乐'||item.title=='音效/混音'){
                    this.formValidate.Fields.push('大后期-'+item.title)
                }else if(item.title=='主笔'||item.title=='清稿'||item.title=='上色'){
                    this.formValidate.Fields.push('漫画-'+item.title)
                }else if(item.title=='分镜'||item.title=='剧本'||item.title=='人设'||item.title=='场设'||item.title=='道具'){
                    this.formValidate.Fields.push('前期-'+item.title)
                }else if(item.title=='其他'||item.title=='3渲2'){
                    this.formValidate.Fields.push(item.title)
                }
            })
        },
        enterTag(){
            this.TabList.push(this.tagName)
            this.formValidate.Skill.push(this.tagName)
            this.tagName='';
        },
        sendTel(){
            var params={
                type:4,
                Tel:this.formValidate.Tel,
                TelCode:this.countries
            }
            if(this.formValidate.Tel&&this.countries){
                this.$post('api/Login/sendCode',params).then(res=>{
                                if(res.code==1){
                                       this.isdisabled=true;
                            var timer= setInterval(()=>{
                                this.Time--;
                                if(this.Time==0){
                                    this.isdisabled=false;
                                    this.Time=60;
                                    clearInterval(timer)
                                }
                                },1000)
                                this.$Message.success(res.msg);
                                }else{
                                    this.$Message.error(res.msg);
                                }
                            })
            }else{
                            this.$Message.error('请输入区号和手机号码')
            }
           
        },
        sendEmail(){//邮箱发送验证码
        var params={
            Email:this.formValidate.Email
        }
        this.$post('api/manage.PersonCenter/sendEmail',params).then(res=>{
            if(res.code==1){
                       this.ismailDisabled=true;
                            var timer= setInterval(()=>{
                                this.emailTime--;
                                if(this.emailTime==0){
                                     this.emailTime=60;
                                    this.ismailDisabled=false;
                                    clearInterval(timer)
                                }
                                },1000)
                this.$Message.success(res.msg);
            }else{
                this.$Message.error(res.msg);
            }
        })
        },
        sureChange(){
           this.modal2=false;
        },
        // getTabList(){
        //   this.$post('api/manage.PersonCenter/tagSkillList').then(res=>{
        //       if(res.code){
        //           this.TabList=res.data;
        //       }
        //   })
        // },
        chooseSkill(item){
          var index = this.formValidate.Skill.indexOf(item);
          if(index>-1){
            this.formValidate.Skill.splice(index,1);
          }else{
            this.formValidate.Skill.push(item)
          }
        },
         handleSubmit(name) {
               
             var that=this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                      var Address={Province:'',City:'',Area:''}
                        if(this.formValidate.Address.length==3){
                            Address.Province=this.formValidate.Address[0];
                            Address.City=this.formValidate.Address[1];
                            Address.Area=this.formValidate.Address[2];
                        }
                        if(this.isMobile&&!this.formValidate.mobileCode){
                            this.$Message.error('手机验证码不能为空')
                             return false;
                        }
                        if(this.isEmail&&!this.formValidate.mailCode){
                            this.$Message.error('邮箱验证码不能为空')
                            return false;
                        }
                    var params={
                        Realname:this.formValidate.Realname,
                        Tel:this.formValidate.Tel,
                        mobileCode:this.formValidate.mobileCode,
                        Email:this.formValidate.Email,
                        EmailCode:this.formValidate.mailCode,
                        QQ:this.formValidate.QQ,
                        WX:this.formValidate.WX,
                        Fields:this.formValidate.Fields,
                        Skill:this.formValidate.Skill.length>0?this.formValidate.Skill.join(','):'',
                        Address:Address,
                        Alipay:this.formValidate.Alipay,
                        AlipayRealname:this.formValidate.AlipayRealname,
                        Bank:this.formValidate.Bank,
                        TelCode:this.countries,
                        Status: 1
                    }
                        this.$post('api/manage.PersonCenter/editMember',params).then(res=>{
                        if(res.code==1){
                                    this.formValidate.Address=Address;
                                    this.formValidate.Status=1;
                                    if(this.formValidate.Skill){
                                        this.formValidate.Skill=this.formValidate.Skill.join(',')
                                    }else{
                                            this.formValidate.Skill='';
                                    }
                                    this.$setLS('AdminInfo',JSON.stringify(this.formValidate));
                                    this.formValidate.Address=[Address.Province,Address.City,Address.Area];
                                    this.formValidate.Skill=this.formValidate.Skill.split(',');
                                    this.$Message.success(res.msg);
                                }else{
                                    this.$Message.error(res.msg);
                                }
                            })
                    } else {
                        this.$Message.error('请将必填内容填写完整!');
                    }
                })
            }
         
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
  
    .contaner{
        background-color: #fff;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        >div:nth-of-type(1){
            overflow: hidden;
            padding:25px;
            border-bottom: 1px solid #E6E9EB;
            img{
                float: left;
            }
            span{
                float: left;
                font-size: 22px;
                color:#334659;
                margin-left: 10px;
            }
            button{
                float: right;
            }
        }
        >div:nth-of-type(2){
            padding:30px 0px;
            box-sizing: border-box;
            input{
                width: 156px;
            }
            .btn-sub{
                border-top: 1px solid #eee;
                padding-top: 20px;
                text-align: center;
            }
            .tab-form{
              
                .tab-btn{
                    display: flex;
                  span:nth-of-type(1){
                    font-size: 32px;
                    border:1px dashed #000;
                    margin-right:10px;
                    color: #000;
                   }
                   span:nth-of-type(2){
                       color: #334659;
                       font-weight: bold;
                       line-height: 32px;
                   }
                }
                .tab-list{
                    width: 430px;
                    overflow: hidden;
                    margin-top: 10px;
                    >span{
                        float: left;
                        border:1px solid #8795A4;
                        background-color:#EEEEEE;
                        color:#334659 ;
                        padding:0px 5px;
                        margin-right: 15px;
                        margin-bottom: 10px;
                        font-size: 12px;
                        line-height: 24px;
                        cursor: pointer;
                       
                    }
                     &>.active{
                         border-color: #01B7F3;
                         background-color:#DDF7FF;
                            color:#0198CD;
                        }
                }
            }
        }
    }
}
  .country{
                position: absolute;
                left: 0px;
                top: 37px;
                z-index: 999;
                width: 200px;
                background-color: #fff;
                border: 1px solid #eee;
                height: 300px;
                overflow-y: scroll;
                li{
                    padding-left: 10px;
                    line-height: 30px;
                  cursor: pointer;
                }
        }

</style>






// WEBPACK FOOTER //
// src/view/HomePage/userInfo.vue